export default {
  version: 'Wersja {version}',
  empty: 'Tutaj pojawią się nowości kolejnych wersji Qmulus.',
  releaseNotes: 'Wszystkie zmiany w wersji {version}',
  versions: 'Wersje',
};
